import SuggestionForm from "../SuggestionForm/SuggestionForm.jsx";
import { useState } from "react";

function SuggestionWidget({ config }) {
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [showFamilyRoleRequired, setShowFamilyRoleRequired] = useState(false);
  const loginPopUp = document.getElementById("login-popup-wrapper");

  const has_role_permission =
    config.has_role_suggestions_permission.toLowerCase() === "true";

  const handleOpenPopUp = () => {
    if (!has_role_permission) {
      //Si hay declarado un rol requerido chequea la condicion
      setShowFamilyRoleRequired(true);
    } else {
      setIsPopUpOpen(true);
    }
  };


  const showLoginPopUp = () => {
    if (loginPopUp) {
      const modal = new bootstrap.Modal(loginPopUp);
      modal.show();
    }
  };

  return (
    <>
      <div className="card p-4 shadow-sm card-border-left w-100 min-height-16em d-flex flex-column align-items-start justify-content-center">
        <i className="fa-solid fa-pen-to-square text-primary fs-1 mb-4"></i>
        <h3 className="h4">{config.translations.suggestionTitle}</h3>
        <button
          onClick={
            config.profile === ""
              ? () => showLoginPopUp()
              : () => handleOpenPopUp()
          }
          className="btn btn-primary mt-4"
        >
          <i className="fa-regular fa-lightbulb"></i>
          {config.translations.suggestionTextBtn}
        </button>
        <p className="SuggestionWidget_roleWarning">
          {showFamilyRoleRequired && config.translations.suggestionErrorRole}
        </p>
      </div>
      {isPopUpOpen && (
        <SuggestionForm
          onHide={() => setIsPopUpOpen(false)}
          show={isPopUpOpen}
          config={config}
        />
      )}
    </>
  );
}

export default SuggestionWidget;
